import PropTypes from "prop-types";
import React, { useState } from "react";
import { Modal, Row, Col, Accordion } from "react-bootstrap";

const Details = (props) => {
  const { userdata } = props;
  const [activeId, setActiveId] = useState(1);

  const toggleAccord = (id) => {
    setActiveId(
      activeId.includes(id)
        ? activeId.filter((i) => i !== id)
        : [...activeId, id]
    );
  };

  return (
    <Modal {...props} size="lg" centered className="calendar-modal self_asset_modal">
      <Modal.Header closeButton>
        <label className="form-label" htmlFor="self">Self Assessment</label>
      </Modal.Header>
      <Modal.Body>
        <Row className="mentor_detail align-items-center">
          <Col sm={12}>
            <div className="faqouter">
              {userdata.diagnostics_sdate !== 0 &&
                userdata.mentee_diagnostics && (
                  <Accordion alwaysOpen defaultActiveKey={["1"]} className="custom-accordion">
                    {userdata.mentee_diagnostics.map((item, index) => (
                      <Accordion.Item eventKey={String(index + 1)} key={item.map}>

                        <Accordion.Header onClick={() => toggleAccord(index + 1)}>
                          <span className="acc-icon">
                            {activeId.includes(index + 1) ? "−" : "+"}
                          </span>
                          <span className="acc-title">
                            Q: {item.question}
                          </span>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div>
                            <i><sup>{item.question_desc}</sup></i>
                          </div>
                          <p>
                            <b>Answer: </b>
                            {item.question_status == 1 &&
                              item.share_date &&
                              item.answer}
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                )}
              {userdata.diagnostics_sdate === 0 && (
                <div style={{ textAlign: "center" }}>
                  <b>No Data Found</b>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    mentee_id: PropTypes.number.isRequired,
    mentor_id: PropTypes.number.isRequired,
    mentee_diagnostics: PropTypes.arrayOf(
      PropTypes.shape({
        question: PropTypes.string,
        question_desc: PropTypes.string,
        question_status: PropTypes.number,
        share_date: PropTypes.string,
        answer: PropTypes.string,
      })
    ),
    diagnostics_sdate: PropTypes.number,
  }).isRequired,
};

export default Details;
